import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Switch,
} from "@mui/material";
import api from "../../api/api";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

dayjs.locale("pt-br");

function Edit(props) {
  const { handleSubmit, control, reset, setValue } = useForm({
    defaultValues: {
      name: "",
      description: "",
      code: "",
      discount: "",
      expiresIn: dayjs().format("YYYY-MM-DD"),
      isUnique: false,
      showInStore: false,
    },
  });

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const response = await api.get(`/vouchers/${props.cupomId}`);
        const {
          name,
          description,
          code,
          discount,
          expiresIn,
          isUnique,
          showInStore,
        } = response.data.voucher;
        setValue("name", name);
        setValue("description", description);
        setValue("code", code);
        setValue("discount", discount);
        setValue("expiresIn", expiresIn.split("T")[0]);
        setValue("isUnique", isUnique);
        setValue("showInStore", showInStore ?? false);
      } catch (error) {
        console.error("Erro ao buscar cupom:", error);
      }
    };

    fetchCoupon();
  }, [props.cupomId]);

  const onSubmit = async (data) => {
    try {
      const formattedDiscount = parseInt(data.discount);
      const formattedDate = dayjs(data.expiresIn).toISOString();
      const res = await api.put(`/vouchers/${props.cupomId}`, {
        ...data,
        expiresIn: formattedDate,
        discount: formattedDiscount,
      });
      if (res.status === 200) {
        props.setStep("");
      }
    } catch (error) {
      console.error("Erro ao editar cupom:", error);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="mb-8">
        <div className="flex items-center justify-between mb-6">
          <Button
            variant="outlined"
            onClick={() => props.setStep("")}
            className="p-2"
          >
            <ArrowBackIcon className="w-5 h-5" />
          </Button>
          <div className="flex-1 text-center">
            <h1 className="text-3xl font-bold text-gray-800">Editar Cupom</h1>
            <p className="text-gray-600 mt-1">
              Modifique as configurações do cupom existente
            </p>
          </div>
          <div className="w-10"></div>{" "}
          {/* Espaçador para centralizar o título */}
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Informações Básicas
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nome do Cupom"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Ex: Desconto de Verão"
                />
              )}
            />

            <Controller
              name="code"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Código do Cupom"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Ex: VERAO2024"
                />
              )}
            />
          </div>

          <div className="mt-6">
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Descrição"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={3}
                  required
                  placeholder="Descreva o cupom e suas condições..."
                />
              )}
            />
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Configurações de Desconto
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Controller
              name="discount"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Desconto (%)"
                  type="number"
                  variant="outlined"
                  fullWidth
                  required
                  inputProps={{ min: 1, max: 100 }}
                  placeholder="Ex: 15"
                />
              )}
            />

            <Controller
              name="expiresIn"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Data de Expiração"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </div>

          <div className="mt-6">
            <Controller
              name="isUnique"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label="Este cupom é de uso único?"
                  className="text-gray-700"
                />
              )}
            />
          </div>
          <div className="mt-6">
            <Controller
              name="showInStore"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch
                      {...field}
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  }
                  label="Exibir cupom no painel de perfil do cliente na loja?"
                  className="text-gray-700"
                />
              )}
            />
          </div>
        </div>

        <div className="flex gap-4 pt-6">
          <Button
            type="button"
            variant="outlined"
            onClick={() => props.setStep("")}
            className="px-6 py-3"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="px-6 py-3"
          >
            Salvar Alterações
          </Button>
        </div>
      </form>
    </div>
  );
}

export default Edit;
